module.exports = __webpack_public_path__ + "img/logo 11.91d2ce8.png";